/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBookingParallelMutationRequest, PostApiBookingParallelMutationResponse, PostApiBookingParallelQueryParams } from "../entities/PostApiBookingParallel";

function getPostApiBookingParallelUrl() {
  const res = { method: 'POST', url: `/api/booking/parallel` as const }
  return res
}

/**
 * @description Создание параллельных записей для родителя и ребенка
 * @summary Создать параллельную запись
 * {@link /api/booking/parallel}
 */
export async function postApiBookingParallel(data: PostApiBookingParallelMutationRequest, params: PostApiBookingParallelQueryParams, config: Partial<RequestConfig<PostApiBookingParallelMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiBookingParallelMutationResponse, ResponseErrorConfig<Error>, PostApiBookingParallelMutationRequest>({ method : "POST", url : getPostApiBookingParallelUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}